export default {
  components: {
  },
  props: ['item', 'projectSubType'],
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
    sumPlant () {
      let num = 0;
      if(this.item.forestList) {
        this.item.forestList.forEach(forestItem => {
          num += Number(forestItem.treeNumber);
        });
        return num;
      }
    }
  },
  methods: {
  }
};
